import {ChangeDetectorRef, Component, Inject, OnInit} from '@angular/core';
import {SharedService} from '../../../shared/shared.service';
import {ActivatedRoute, Router} from '@angular/router';
import {LocalStorageService} from 'angular-2-local-storage';
import {ManageCardsService} from '../manage-cards.service';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';
import {FormControl, Validators} from '@angular/forms';
import * as moment from 'moment'
import {PaymentusService} from '../../paymentus/paymentus.service';

declare var $: any;

const ZIPCODE_REGEX = /^[0-9]{5}(?:-[0-9]{4})?$/;
const DATE_REGEX = /^(0[1-9]|1[0-2])\/?([0-9]{2})$/;

@Component({
  selector: 'app-manage-card-on-file',
  templateUrl: './manage-card-on-file.component.html',
  styleUrls: ['./manage-card-on-file.component.css']
})
export class ManageCardOnFileComponent implements OnInit {
  zipCodeFormControl = new FormControl('', [
    Validators.required,
    Validators.pattern(ZIPCODE_REGEX)]);

  cardExpirationFormControl = new FormControl('', [
    Validators.required,
    Validators.pattern(DATE_REGEX)]);

  protected readonly moment = moment;
  public card_details: Array<any>;
  public temporaryPrimaryProfile;
  public isChangingDefault = false;
  public isCardErrors = false;
  public isSettingPrimaryCard = false;
  public card_detail_update: Object;
  public card_ending_digit: string;
  public expiration_date;
  public ccv;
  public card_type: string;
  public card_name: Object;
  public card_name_update: string;
  public is_savecard_loader: boolean;
  public autopay_amount: number;
  public minimum_balance: number;
  public primary_card: any;
  public auto_pay: boolean;
  public process_auto_pay: boolean;
  public autopayMinimum: number;
  public is_autopay_blocked: boolean;
  public billing_zip_code;
  public billToZip: boolean;
  public is_billingZip_error: boolean;
  public validateCard_error: string;
  public zipCode_valid: boolean;
  public update_button: string;
  public isUpdatingCard = false;
  public selected_CardID: string;
  public isEditingCard = false;
  public updateCardMessage = '';
  public currentCardBeingEdited = undefined;
  public newExpirationDate = undefined;
  public date = new FormControl(moment());
  public isValidExpirationDate = false;

  constructor(
    private dialog: MatDialog,
    private sharedService: SharedService,
    private router: Router,
    private localStorageService: LocalStorageService,
    private activatedRoute: ActivatedRoute,
    private manageCardsService: ManageCardsService,
    private paymentusService: PaymentusService,
    private changeDetectorRefs: ChangeDetectorRef
  ) {
    this.sharedService.setHeaderTitle('manage_card');

    this.is_savecard_loader = true;
    this.billToZip = true;
    this.zipCode_valid = false;
    this.minimum_balance = 0;
    this.autopay_amount = 0;
    this.auto_pay = false;
    this.update_button = 'Update';
    console.log('here?')
    if (this.localStorageService.get('token') != null) {
      this.sharedService.verifyToken({ 'token': this.localStorageService.get('token') })
        .then((res) => {
          if (res.cashOnly) {
            this.router.navigate(['./dashboard']);
          }
          console.log(0)
          if (res.status === 'success' && res.isTerminated === false) {
            console.log(1)
            if (!res.isEnrolled) {
              this.router.navigate(['./dashboard']);
            } else {
              const person = res.results[0]['personal'][0];

              // Used for dataLayer.push
              const dataLayerAccountInfo = res.results[0]['personal'];

              const dataLayerEvent = 'manage card on file';
              (window as any).dataLayer.push({
                'event': dataLayerEvent,
                'accountID': dataLayerAccountInfo[0].id.toString(),
                'accountNumber': dataLayerAccountInfo[0].accountNumber.toString()
              })
              res.results[0].cards.map((result) => {
                if (result.defaultPaymentProfile) {
                  this.primary_card = result;
                  this.expiration_date = result.expiryDate;
                  this.card_ending_digit = result.cardNo;
                  this.billToZip = result.billToZip;
                  if (!this.billToZip) {
                    this.isEditingCard = true;
                    this.currentCardBeingEdited = this.primary_card;
                    this.newExpirationDate = moment(this.primary_card.expiryDate).format('MM/YY');
                    this.billing_zip_code = this.primary_card.billToZip;
                  }
                }
              });

              const this_obj = this;
              this.minimum_balance = person['balThreshold'];
              this.autopay_amount = person['autoPayAmount'];
              this.is_autopay_blocked = Boolean(person['isBlockAutopay']).valueOf();
              if (this.is_autopay_blocked) {
                this.router.navigate(['./manage_payment_methods']);
              }
              setTimeout(function () {
                this_obj.sharedService.setHeaderUserLoggedIn('manage_card', true, person);
              }, 10);
              console.log('updating')
              this.updateCards()
              this.sharedService.getConfigConst()
                .then((res2) => {
                  if (res2.status === 'success') {
                    this.autopayMinimum = res2.results[0]['autopayAmount'];
                  }
                });
            }
          } else {
            this.localStorageService.remove('token');
            this.localStorageService.set('returnUrl', 'manage_payment_methods');
            this.router.navigate(['./sign-in']);
          }
        });
    } else {
      this.localStorageService.set('returnUrl', 'manage_payment_methods');
      this.router.navigate(['./sign-in']);
    }
  }

  updateCards() {
    this.paymentusService.fetchPaymentProfiles(this.localStorageService.get('token')).then(res1 => {
      console.log('data', res1)
      if (res1 && res1.profiles) {
        this.cardTypeConvert(res1.profiles);
        this.primary_card = res1.profiles.find(card => card.default === true);
        this.card_details = res1.profiles.filter(card => card.default !== true);
      }
      this.is_savecard_loader = false;
    });
    this.manageCardsService.getAutoPay({ 'token': this.localStorageService.get('token') }).then(res2 => {
      if (res2.status === 'success') {
        this.auto_pay = res2.autopayActive;
        this.localStorageService.set('autoPay', this.auto_pay);
      }
    });
  }

  cardTypeConvert(card_types: any) {
    this.card_name = {};
    for (const card_type of card_types) {
      this.card_name[card_type.cardNo] = card_type.cardType;
    }
  }

  setPrimaryCard(card_id: any, popup: boolean = true) {
    let card_detail = this.card_details ? this.card_details.find(card => card && card.paymentProfileId === card_id) : undefined;
    const isPrimaryCard = this.primary_card && this.primary_card.paymentProfileId === card_id;
    if (isPrimaryCard) {
      card_detail = this.primary_card;
    }
    if (isPrimaryCard) {
      this.isSettingPrimaryCard = false;
      return;
    }
    this.isSettingPrimaryCard = true;
    if (card_detail && !card_detail.billToZip) {
      const idx = this.card_details.indexOf(card_detail);
      this.triggerCardUpdate(idx, false);
      return;
    }
    this.temporaryPrimaryProfile = card_detail;
    this.expiration_date = card_detail.expiryDate;
    this.card_ending_digit = card_detail.cardNo;
    this.card_name_update = card_detail.cardType;

    const data = {
      'token': this.localStorageService.get('token'),
      'payAccId': card_id
    }
    this.is_billingZip_error = false;
    this.selected_CardID = card_id;
    this.billing_zip_code = null;
    this.update_button = 'Update';
    this.isChangingDefault = true;
  }
  confirmDefault(option) {
    const data = {
      'token': this.localStorageService.get('token'),
      'payAccId': this.temporaryPrimaryProfile.paymentProfileId
    }
    this.manageCardsService.setPrimaryCard(data).then(res => {
      if (res.status === 'success') {
        this.card_details.push(this.primary_card);
        this.card_details = this.card_details.filter(card => card && card.paymentProfileId !== this.temporaryPrimaryProfile.paymentProfileId);
        this.primary_card = this.temporaryPrimaryProfile
      }
      this.isChangingDefault = false;
      this.isSettingPrimaryCard = false;
    });
  }

  getLast4Digit(card_number: any) {
    const digit = card_number.split('-');
    return '*****' + digit[3];
  }

  deleteCard(card_id: any, i) {
    let autopayCard = false;
    if (this.auto_pay && this.primary_card === card_id) {
      autopayCard = true;
    }
    const data = {
      'token': this.localStorageService.get('token'),
      'customerPaymentProfileId': card_id,
      'autopay': this.auto_pay
    }
    const dialogRef = this.dialog.open(ConfirmDeleteCard, {
      data: { profile: data }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.is_savecard_loader = true;
      if (result.status) {

        this.paymentusService.fetchPaymentProfiles(this.localStorageService.get('token')).then(res1 => {
          if (res1.profiles) {
            this.cardTypeConvert(res1.profiles);
            this.primary_card = res1.profiles.find(card => card.default === true);
            this.card_details = res1.profiles.filter(card => card.default !== true);
          }
          this.is_savecard_loader = false;
        });
        this.manageCardsService.getAutoPay({ 'token': this.localStorageService.get('token') }).then(res2 => {
          if (res2.status === 'success') {
            this.auto_pay = res2.autopayActive;
            this.localStorageService.set('autoPay', this.auto_pay);
          }
        });
        this.card_details.splice(i, 1);
      }
    });
  }

  ngOnInit() {

  }

  getAutoPay() {
    this.is_savecard_loader = true;
    this.manageCardsService.getAutoPay({ 'token': this.localStorageService.get('token') }).then(res2 => {
      if (res2.status === 'success') {
        this.auto_pay = true;
        this.localStorageService.set('autoPay', true);
        this.is_savecard_loader = false;
      }
    });
  }

  autoPayChange() {

    if (this.autopay_amount < this.autopayMinimum) {
      const dialogRef = this.dialog.open(SuccessMessage, {
        // data: { message: 'Please add/set at least one Card as Primary for autopay.' }
        data: {
          message: 'A minimum of $' + this.autopayMinimum + ' is required for Autopay. Please update your Autopay amount settings.'
        }
      });
      this.getAutoPay();
    } else {
      if (this.primary_card !== 0 && this.primary_card != null) {
        const auto_status = !this.auto_pay;
        const data = {
          'active': auto_status,
          'token': this.localStorageService.get('token')
        }

        this.process_auto_pay = true;
        this.is_savecard_loader = true;

        this.manageCardsService.setAutoPay(data).then(res => {
          if (res.status === 'success') {
            this.process_auto_pay = false;
            this.auto_pay = auto_status;
            this.localStorageService.set('autoPay', this.auto_pay);
            const dialogRef = this.dialog.open(SuccessMessage, {
              data: { message: res.message }
            });
          } else {
            this.process_auto_pay = false;
            const dialogRef = this.dialog.open(SuccessMessage, {
              // data: { message: 'Please add/set at least one Card as Primary for autopay.' }
              data: { message: res.message  }
            });
          }
          this.is_savecard_loader = false;
        });
      } else {
        if (this.auto_pay) {
          const auto_status = !this.auto_pay;
          const data = {
            'active': auto_status,
            'token': this.localStorageService.get('token')
          }

          this.process_auto_pay = true;
          this.is_savecard_loader = true;

          this.manageCardsService.setAutoPay(data).then(res => {
            if (res.status === 'success') {
              this.process_auto_pay = false;
              this.auto_pay = auto_status;
              this.localStorageService.set('autoPay', this.auto_pay);
              const dialogRef = this.dialog.open(SuccessMessage, {
                data: { message: res.message }
              });
            }
            this.is_savecard_loader = false;
          });
        } else {
          let message = '';
          if (this.card_details === undefined || this.card_details.length === 0){
            message = 'Please add at least one card to activate autopay.'
          }else if (this.primary_card === undefined){
            message = 'Please click on a card in the list to make it your primary card to activate autopay'
          }
          const dialogRef = this.dialog.open(SuccessMessage, {
            // data: { message: 'Please add/set at least one Card as Primary for autopay.' }
            data: { message: message }
          });
        }

        this.auto_pay = true;
      }
    }
  }

  billingZipCodeValidate(credit_card: any) {
    this.zipCode_valid = false;
    this.validateCard_error = null;
    if (this.billing_zip_code !== '' && this.billing_zip_code !== undefined  && this.billing_zip_code.match(ZIPCODE_REGEX)) {
      this.billToZip = false;
      this.zipCode_valid = true;
    }
    const formatted = moment(this.newExpirationDate, 'MM/YY');
    this.isValidExpirationDate = false;
    if (this.newExpirationDate.match(DATE_REGEX)) {
      this.isValidExpirationDate = formatted.isValid()
    }
  }
  validateCardUpdate() {
	  console.log('gets here')
    const formatted = moment(this.newExpirationDate, 'MM/YY');
	  console.log('date: ', this.newExpirationDate, formatted)

    this.isValidExpirationDate = false;
    if (this.newExpirationDate.match(DATE_REGEX)) {
      this.isValidExpirationDate = formatted.isValid()
		console.log(this.isValidExpirationDate)
    }
    this.zipCode_valid = false;
    this.validateCard_error = null;
    if (this.billing_zip_code !== '' && this.billing_zip_code !== undefined  && this.billing_zip_code.match(ZIPCODE_REGEX)) {
      this.billToZip = false;
      this.zipCode_valid = true;
    }
  }
  triggerCardUpdate(index: number, isPrimary: boolean = false, func: Function = () => {}) {
    this.isEditingCard = true;
    if (isPrimary) {
      this.primary_card.isEditing = true;
      this.currentCardBeingEdited = this.primary_card;
      this.newExpirationDate = moment(this.primary_card.expiryDate).format('MM/YY');
      this.billing_zip_code = this.primary_card.billToZip;
    } else {
      this.card_details[index].isEditing = true;
      this.currentCardBeingEdited = this.card_details[index];
      this.newExpirationDate = moment(this.card_details[index].expiryDate).format('MM/YY');
      this.billing_zip_code = this.card_details[index].billToZip;
    }
  }
  anyCardErrors() {
    return this.card_details && this.card_details.some(card => card && (!card.billToZip || card.billToZip === false));
  }
  updateCreditCard() {
    this.zipCode_valid = false;
    this.isUpdatingCard = true;
    this.update_button = 'Updating...';
    this.card_detail_update = {
      'CardNumber': this.card_ending_digit ? this.card_ending_digit.substring(this.card_ending_digit.length - 4) : this.currentCardBeingEdited.cardNo,
      PaymentProfileId: this.currentCardBeingEdited.paymentProfileId,
      'ExpireMonthYear': this.newExpirationDate,
      'CCV': this.ccv,
      'CardZipCode': this.billing_zip_code,
      'token': this.localStorageService.get('token'),
      'cardName': this.card_name_update,
      'cardType': this.card_type,
		isDefault: this.currentCardBeingEdited.default
    }

    this.manageCardsService.updateCard(this.card_detail_update).then(res => {
      if (res.status === 'fail') {
        // this.validateCard_error = res.messages.message[0].text;
        this.billToZip = true;
        this.is_billingZip_error = true;
        this.zipCode_valid = false;
        this.isUpdatingCard = false;
        this.update_button = 'Update';
        this.updateCardMessage = res.message;
        setTimeout(() => {
          this.updateCardMessage = '';
        }, 10000);
      } else {
        this.isUpdatingCard = false;
        this.update_button = 'Update';
        this.updateCardMessage = 'Successfully updated card details.'
        setTimeout(() => {
          this.updateCardMessage = '';
        }, 10000);

        this.paymentusService.fetchPaymentProfiles(this.localStorageService.get('token')).then(res1 => {
          if (res1.profiles) {
            this.cardTypeConvert(res1.profiles);
            this.primary_card = res1.profiles.find(card => card.default === true);
            this.card_details = res1.profiles.filter(card => card.default !== true);
            this.is_savecard_loader = false;
            if (this.isSettingPrimaryCard) {
              this.setPrimaryCard(this.currentCardBeingEdited.paymentProfileId, false)
            }
            this.isEditingCard = false;
            this.currentCardBeingEdited = undefined;
          }
          this.is_savecard_loader = false;
        });
        this.manageCardsService.getAutoPay({ 'token': this.localStorageService.get('token') }).then(res2 => {
          if (res2.status === 'success') {
            this.auto_pay = res2.autopayActive;
            this.localStorageService.set('autoPay', this.auto_pay);
          }
        });
      }
    });
  }
}

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'change-primary-card',
  // tslint:disable-next-line:max-line-length
  template: '<div class="dialog-main"><div class="dialog-info"><p>This card will get charged during auto payment. Are you sure you want to set this card as primary?</p></div></div><div class="footer"><button mat-button class="double-block-btn" (click)="changePrimaryCard()" style="width:50%;display: inline-block;border-bottom-left-radius: 7px;">Ok</button><button mat-button class="double-block-btn" (click)="cancel()" style="width:50%;display: inline-block;border-bottom-right-radius: 7px;">Cancel</button></div>'
})
// tslint:disable-next-line:component-class-suffix
export class ChangePrimaryCard {
  constructor(public dialogRef: MatDialogRef<ChangePrimaryCard>, private dialog: MatDialog,
              @Inject(MAT_DIALOG_DATA) public data: any, public manageCardsService: ManageCardsService) {

  }

  changePrimaryCard() {
    this.dialogRef.close({ 'status': true });
    this.manageCardsService.setPrimaryCard(this.data.cardname).then(res => {
      if (res.status === 'success') {
        this.dialogRef.close({ 'data': this.data.cardname, 'status': true });
        const goodDialog = this.dialog.open(SuccessMessage, {
          data: { message: res.message }})
      } else {
        const badDialog = this.dialog.open(SuccessMessage, {
          data: { message: res.message }})
      }
    });
  }

  cancel() {
    this.dialogRef.close({ 'status': false });
  }
}

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'success-message',
  // tslint:disable-next-line:max-line-length
  template: '<div class="dialog-main"><div class="dialog-info"><p>{{message}}</p></div></div><div class="footer"><button mat-button class="double-block-btn" (click)="ok()" style="inline-block;border-bottom-right-radius: 7px;border-bottom-left-radius: 7px;">Ok</button></div>'
})
// tslint:disable-next-line:component-class-suffix
export class SuccessMessage {
  public message: string;
  constructor(public dialogRef: MatDialogRef<SuccessMessage>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.message = this.data.message;
  }
  ok() {
    this.dialogRef.close();
  }
}

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'confirm-delete-card',
  // tslint:disable-next-line:max-line-length
  template: '<div class="dialog-main"><div class="dialog-info"><p style="text-align:center">Are you sure you want to delete this card?</p><ng-template [ngIf]="data.profile.autopay"><div><p style="text-align:center">If this is your primary card, you will be removed from autopay.</p></div></ng-template></div></div><div class="footer"><button mat-button class="double-block-btn" (click)="confirmDeleteCard()" style="width:50%;display: inline-block;border-bottom-left-radius: 7px;">Ok</button><button mat-button class="double-block-btn" (click)="cancel()" style="width:50%;display: inline-block;border-bottom-right-radius: 7px;">Cancel</button></div>'
})
// tslint:disable-next-line:component-class-suffix
export class ConfirmDeleteCard{
  constructor(public dialogRef: MatDialogRef<ConfirmDeleteCard>,
              @Inject(MAT_DIALOG_DATA) public data: any, public manageCardsService: ManageCardsService, private dialog: MatDialog) {

  }

  confirmDeleteCard() {

    this.manageCardsService.deleteCard(this.data.profile).then(res => {
      if (res.status === 'success') {
        this.dialogRef.close({ 'status': true });
        const goodDialog = this.dialog.open(SuccessMessage, {
          data: { message: res.message }})
      } else {
        this.cancel();
      }
    });
  }

  cancel() {
    this.dialogRef.close({ 'status': false });
  }

}



// WEBPACK FOOTER //
// ./src/app/payment/manage-cards/manage-card-on-file/manage-card-on-file.component.ts